// lib/utils.js
import { z } from "zod";

const formValidationSchema = z.object({
  firstName: z.string()
    .min(1, "First name is required")
    .min(2, "First name must be at least 2 characters")
    .max(50, "First name must be less than 50 characters")
    .regex(/^[a-zA-Z\s'-]+$/, "First name can only contain letters, spaces, hyphens, and apostrophes"),

  lastName: z.string()
    .min(1, "Last name is required")
    .min(2, "Last name must be at least 2 characters")
    .max(50, "Last name must be less than 50 characters")
    .regex(/^[a-zA-Z\s'-]+$/, "Last name can only contain letters, spaces, hyphens, and apostrophes"),
    
  email: z.string()
    .min(1, "Email is required")
    .email("Please enter a valid email address")
    .max(100, "Email must be less than 100 characters"),
    
  message: z.string()
    .min(1, "Please tell us how the Courtesy Patrol helped you")
    .min(10, "Please provide more detail about how we helped you")
    .max(1000, "Message must be less than 1000 characters"),
  
  safetyRating: z.string()
    .min(1, "Please rate the driver's concern for your safety"),
    
  professionalismRating: z.string()
    .min(1, "Please rate the driver's professionalism"),
    
  overallRating: z.string()
    .min(1, "Please provide an overall service rating")
});

export const validateFormData = (formData) => {
  try {
    formValidationSchema.parse(formData);
    return { isValid: true, errors: {} };
  } catch (error) {
    if (error instanceof z.ZodError) {
      const errors = {};
      error.errors.forEach((err) => {
        if (err.path[0]) {
          errors[err.path[0]] = err.message;
        }
      });
      return { isValid: false, errors };
    }
    return { isValid: false, errors: { general: "Validation failed" } };
  }
};